
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, IsString, IsNumber } from "class-validator";
export class VillageNameRequest {
  @ApiProperty()
  villageName: string;
}
export class VillageIdRequest {
  @ApiProperty()
  Id: number;
}
export class villageCodeRequest {
  @ApiProperty()
  villageCode: string;
  @ApiProperty()
  status: boolean;
}
